const Reviews: React.FC = () => {
  return (
    <section id="sweptbooks-reviews" className="container">

    </section>
  )
}

export default Reviews